import { render, staticRenderFns } from "./StatisticCardVerticalPending.vue?vue&type=template&id=40e67b57&"
import script from "./StatisticCardVerticalPending.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports